export default class Datatable {
  constructor() {
    this.initialize();
  }

  initialize() {
    const self = this;
    const sortColumns = document.querySelectorAll(".js-sort-column");
    if (sortColumns.length) {
      sortColumns.forEach((el) => {
        el.addEventListener("click", (e) => {
          const table = self.createTableObject(
            "#" + e.target.closest("table").id
          );

          table.sorting.uiColumn = ((e) => {
            const el = e._sdListenerTarget;
            return el.localName === "th" ? el : el.closest("th");
          })(e);
          const a = (table.sorting.uiIndicator = ((e) => {
            if (e.target.localName === "i") {
              return e.target.parentNode;
            }
            return e.target;
          })(e));

          table.sorting.type =
            a.getAttribute("data-sort") === "desc" ? "asc" : "desc";

          self.clearSorting(table);
          self.updateColumnSorting(table);

          const wrapper = table.uiRoot.parentNode;
          wrapper.style.height = table.uiRoot.clientHeight + 16 + "px";
          wrapper.style.overflow = "hidden";

          setTimeout(() => {
            table.uiRows.forEach((tr) => {
              tr.style.display = "";
            });
            self.sortTable(table);
            self.updatePagination(table);
            wrapper.style.height = "auto";
            wrapper.style.overflow = "visible";
          }, 20);
        });
      });
    }

    const pagItems = document.querySelectorAll(".js-pag-item");
    if (pagItems.length) {
      pagItems.forEach((el) => {
        el.addEventListener("click", (e) => {
          const el = e.target;
          const type = el.getAttribute("data-type");
          const tableSelector =
            "#" + el.closest(".js-pagination").getAttribute("data-table");
          const table = self.createTableObject(tableSelector);

          switch (type) {
            case "page":
              table.pagination.page = parseInt(el.getAttribute("data-page"));
              break;
            case "first":
              table.pagination.page = 1;
              break;
            case "last":
              table.pagination.page = table.pagination.pagesNum;
              break;
            case "prev":
              table.pagination.page = table.pagination.page - 1;
              break;
            case "next":
              table.pagination.page = table.pagination.page + 1;
              break;
          }

          self.updatePagination(table);
        });
      });
    }

    const datatables = document.querySelectorAll(".datatable");

    if (datatables.length) {
      datatables.forEach((datatableElement) => {
        $(datatableElement).on("click", "tbody tr", function (evt) {
          const el = evt.target;

          let preventable = self.findClosest(el, ".js-prevent-redirection");
          if (preventable) {
            return true;
          }

          let anchor = self.findClosest(el, "a");
          if (anchor) {
            evt.preventDefault()
            self.clickAnchor(anchor);
            return true;
          }

          let row = self.findClosest(el, "tr");
          if (!row) {
            return true;
          }

          let href = row.getAttribute("data-href");
          if (!href) {
            return true;
          }

          top.document.location = href;
        });

        const table = self.createTableObject("#" + datatableElement.id);
        self.updatePagination(table);
      });
    }
  }

  findClosest(el, selector) {
    if (el.matches(selector)) {
      return el;
    }
    return el.closest(selector);
  }

  clickAnchor(anchor) {
    if (anchor.classList.contains("load-action")) {
      this.loadAction(anchor);
      return;
    }
    top.document.location = anchor.getAttribute("href");
  }

  loadAction(anchor) {
    let href = anchor.getAttribute("href");
    let name = anchor.getAttribute("data-name");
    let icon = anchor.getAttribute("data-icon");
    let display = anchor.getAttribute("data-display");
    top.loadAction(href, name, icon, display);
  }

  // Table sorting.
  // --------------------------------------------------------------------------

  getCellValue = (tr, idx) => {
    const td = tr.children[idx];

    const select = td.querySelector("select");
    if (select) {
      return select.value;
    }

    return td.innerText || td.textContent;
  };

  comparer = (idx, asc) => (a, b) =>
    ((v1, v2) =>
      v1 !== "" && v2 !== "" && !isNaN(v1) && !isNaN(v2)
        ? v1 - v2
        : v1.toString().localeCompare(v2))(
      getCellValue(asc ? a : b, idx),
      getCellValue(asc ? b : a, idx)
    );

  /**
   * Create table object.
   * @param {string} selector Table.
   * @return {Object}
   */
  createTableObject(selector) {
    const table = document.querySelector(selector);

    if (!(table instanceof HTMLTableElement)) {
      throw TypeError(
        "First argument passed to createTableObject should be selector pointing to table element."
      );
    }

    // Sorting.
    const th = this.findSortingColumn(table);
    const a = th ? th.querySelector("a") : null;

    // Body.
    const uiBody = table.querySelector("tbody");

    const rows = uiBody.querySelectorAll("tr");
    const perPage = 20;
    const total = rows.length;
    const pagesNum = Math.ceil(total / perPage);
    const uiPag = document.querySelector(selector + "_pagination");

    return {
      uiRoot: table,
      uiHead: table.querySelector("thead"),
      uiBody: uiBody,
      uiRows: uiBody.querySelectorAll("tr"),
      sorting: {
        uiColumn: th,
        uiIndicator: a,
        type: a && a.getAttribute("data-sort") === "desc" ? "asc" : "desc",
      },
      pagination: uiPag
        ? {
            uiRoot: uiPag,
            uiPages: uiPag.querySelector(".js-pages"),
            uiTotal: uiPag.querySelector(".js-pag-total"),
            uiFirstIndex: uiPag.querySelector(".js-pag-first-index"),
            uiLastIndex: uiPag.querySelector(".js-pag-last-index"),
            page: parseInt(uiPag.getAttribute("data-page")) || 1,
            perPage,
            total,
            pagesNum,
          }
        : null,
    };
  }

  /**
   * Finds column which is used for sorting.
   * @param {HTMLTableElement} uiTable
   * @return {HTMLTableElement}
   */
  findSortingColumn(uiTable) {
    return uiTable.querySelector(".js-active-sort");
  }

  /**
   * Remove all sortinf from table.
   * @param {Object} table
   */
  clearSorting(table) {
    table.uiHead.querySelectorAll(".js-sort-column").forEach((th) => {
      th.classList.remove("js-active-sort");
      const a = th.querySelector("a");
      a.setAttribute("data-sort", "");
      a.querySelector("i").classList.remove("fa-sort-up", "fa-sort-down");
    });
  }

  /**
   * Mark column as the one currently used for sorting.
   * @param {Object} table
   */
  updateColumnSorting(table) {
    const { uiIndicator, type } = table.sorting;
    const icon = uiIndicator.querySelector("i");
    if (type === "asc") {
      uiIndicator.setAttribute("data-sort", "asc");
      icon.classList.remove("fa-sort-up");
      icon.classList.add("fa-sort-down");
    } else {
      uiIndicator.setAttribute("data-sort", "desc");
      icon.classList.remove("fa-sort-down");
      icon.classList.add("fa-sort-up");
    }
  }

  /**
   * Sort table.
   * @param {Object} table
   */
  sortTable(table) {
    const { uiColumn, type } = table.sorting;
    table.uiRows
      .sort(
        comparer(
          Array.from(uiColumn.parentNode.children).indexOf(uiColumn),
          type === "asc"
        )
      )
      .forEach((tr) => table.uiBody.appendChild(tr));
  }

  /**
   * Build/Update table pagination.
   * @param {Object} table
   */
  updatePagination(table) {
    const { pagination } = table;

    if (!pagination) {
      return;
    }

    const firstIndex = (pagination.page - 1) * pagination.perPage + 1;
    const lastIndex = pagination.page * pagination.perPage;

    pagination.uiTotal.innerHTML = pagination.total;
    pagination.uiFirstIndex.innerHTML = firstIndex;
    pagination.uiLastIndex.innerHTML = lastIndex;

    table.uiRows.forEach((tr, index) => {
      index++;
      tr.style.display =
        index >= firstIndex && index <= lastIndex ? "" : "none";
    });

    if (pagination.pagesNum > 1) {
      const html = [];

      html.push(`<ul class="pagination col justify-content-end">`);
      if (pagination.page !== 1) {
        html.push(`
          <li class="page-item"><a class="page-link pointer js-pag-item" data-type="first">First</a></li>
          <li class="page-item"><a class="page-link pointer js-pag-item" data-type="prev"><i class="fas fa-chevron-left fa-xs"></i></a></li>
        `);
      }

      for (let i = 0; i < pagination.pagesNum; i++) {
        const active = i + 1 === pagination.page ? "active" : "";
        html.push(`
          <li class="page-item ${active}"><a class="pointer page-link page js-pag-item" data-page="${
          i + 1
        }" data-type="page">${i + 1}</a></li>
        `);
      }

      if (pagination.page !== pagination.pagesNum) {
        html.push(`
          <li class="page-item"><a class="page-link pointer js-pag-item" data-type="next"><i class="fas fa-chevron-right fa-xs"></i></a></li>
          <li class="page-item"><a class="page-link pointer js-pag-item" data-type="last">Last</a></li>
        `);
      }

      html.push(`</ul>`);

      pagination.uiPages.innerHTML = html.join("\n");
    }
  }
}
